import { text } from './constants'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const generateRescheduleMessage = ({ IsVisitTypeAvailable, isPriceChanged, status }) => {
  const messages = []
  if (isPriceChanged) messages.push(text.ADDITIONAL_PAYMENT_REASON)
  if (status === text.IN_PROGRESS_STATUS) messages.push(text.IN_PROGRESS_REASON)
  if (status === text.IN_WAITING_ROOM_BACK) messages.push(text.IN_PROGRESS_REASON)
  if (!IsVisitTypeAvailable) messages.push(text.PROVIDER_NOT_LICENSED_REASON)

  return messages
}
